import { HttpClinet } from './../utils/config'

export const contactAPI = {
    getContact: (data) => {
        return HttpClinet({
            url: `/document/contract`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
}